/**
 * API Configuration
 * Centralized configuration for all API endpoints and related settings
 */

export const API_CONFIG = {
  // Gemini AI API
  GEMINI: {
    ENDPOINT: 'https://generativelanguage.googleapis.com/v1beta/models/gemini-3.8-flash:generateContent',
    TIMEOUT: 30000, // 30 seconds
    RETRY_ATTEMPTS: 3,
  },

  // Request timeouts
  TIMEOUTS: {
    DEFAULT: 30000, // 30 seconds
    UPLOAD: 120000, // 2 minutes
    FILE_PROCESSING: 60000, // 1 minute
  },

  // HTTP status codes
  STATUS_CODES: {
    SUCCESS: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    INTERNAL_ERROR: 500,
  },

  // Request headers
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
  },
};

export default API_CONFIG;